// extracted by css-extract-rspack-plugin
export default {"root":"fen4j0bYPqsfrjjq"};